// @flow
/** @jsx jsx */

import * as React from 'react';

import FormLabel from '../FormLabel';
import { jsx } from '@emotion/core';

type Props = {
  /** Children to render inside field container */
  children: React.Node,
  /** `true` if the input should be rendered before the label */
  inputFirst?: boolean,
  /** `true` if it should render inline instead of as a block. Defaults to `false`. */
  isInline?: boolean,
  /** Field label */
  label: string,
};

const formFieldCss = (isInline?: boolean) =>
  isInline
    ? {
        display: 'flex',
        alignItems: 'center',
      }
    : {
        display: 'block',
      };

const labelCss = (props: Props) => ({
  marginLeft: props.isInline && props.inputFirst ? '1em' : 0,
  marginRight: props.isInline && !props.inputFirst ? '1em' : 0,
});

const FormField = (props: Props) => {
  const { children, inputFirst, isInline, label } = props;

  return (
    <label css={formFieldCss(isInline)}>
      {inputFirst && children}
      <span css={labelCss(props)}>
        <FormLabel isInline={isInline} isSpan={true}>
          {label}
        </FormLabel>
      </span>
      {!inputFirst && children}
    </label>
  );
};

export default FormField;
